import React from "react"

import FeaturedServicesSectionDesktop from "./FeaturedServicesSectionDesktop"
import FeaturedServicesSectionMobile from "./FeaturedServicesSectionMobile"

const FeaturedServicesSection = ({
  section,
  practice,
  theme,
  highlightedField,
  pageSlug,
  viewMode = "",
  deviceType = "desktop"
}) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return (
      <FeaturedServicesSectionMobile
        section={section}
        practice={practice}
        theme={theme}
        highlightedField={highlightedField}
        pageSlug={pageSlug}
      />
    )
  }

  if (viewMode === "desktop") {
    return (
      <FeaturedServicesSectionDesktop
        section={section}
        practice={practice}
        theme={theme}
        highlightedField={highlightedField}
        pageSlug={pageSlug}
      />
    )
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return (
      <FeaturedServicesSectionMobile
        section={section}
        practice={practice}
        theme={theme}
        highlightedField={highlightedField}
        pageSlug={pageSlug}
      />
    )
  }

  // Default to desktop for desktop devices
  return (
    <FeaturedServicesSectionDesktop
      section={section}
      practice={practice}
      theme={theme}
      highlightedField={highlightedField}
      pageSlug={pageSlug}
    />
  )
}

export default FeaturedServicesSection
